import Link from '../../views/ApproveMsg';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { actions } from '../../../state/assessment';
import { actions as statusactions } from '../../../state/status';
import { actions as authactions } from '../../../state/auth';

const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  project: state.shift.project[ownProps.match.params.projectId],
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  membername: state.shift.assessment.membername,
  memberusername: state.shift.assessment.memberusername,
  memberemail: state.shift.assessment.memberemail,
  membertelephone: state.shift.assessment.membertelephone,
  memberrole: state.shift.assessment.memberrole,
  nextaction: state.shift.assessment.nextaction,
  data: state.shift.status.payload
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    clickOKHandler: value => {
      // localStorage.clear();
      // sessionStorage.clear();
      // dispatch(authactions.logout());
      dispatch(authactions.logout())
        .then(dispatch(()=>{
          localStorage.clear();
          sessionStorage.clear();
          actions.resetAssessmentStore();
          statusactions.resetStatus();
          window.location.reload();
        }));
    },

    approve: (username, email, name, role) =>
      dispatch(actions.approve(username, email, name, role)),

    reject: username => dispatch(actions.reject(username)),

    sendfinalapprove: (username, email, name, role) =>
      dispatch(actions.sendfinalapprove(username, email, name, role))

  };
};

const ApproveMsg = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default ApproveMsg;



// WEBPACK FOOTER //
// ./src/components/container/ApproveMsg/index.js